<template>
  <div>
    <div v-if="status === 't'">
      <vs-divider class="text-5xl"> Our Plans </vs-divider>
      <p class="text-3xl text-center">Start your business for free for <span class="days">14</span> days.</p>
      <p class="text-3xl text-center">Choose a plan that suits your business best.</p>
    </div>
  <div class="container">
    <div class="panel pricing-table">
      <div v-for="(plan, index) in plans" :key="index" :class="currentPlan(plan.id)">
        <div v-if="currentTag(plan.id)" class="current_plan"><div class="sub-current-plan1"></div> Current Plan <div class="sub-current-plan2"></div></div>
        <img v-if="index === 0" src="@/assets/images/subscription plan/airballon.png" alt="" class="pricing-img">
        <img v-else-if="index === 1" src="@/assets/images/subscription plan/plane.png" alt="" class="pricing-img">
        <img v-else src="@/assets/images/subscription plan/rocket.png" alt="" class="pricing-img">
        <h2 class="pricing-header">{{plan.name}}</h2>
        <ul class="pricing-features">
          <li class="pricing-features-item">Create <span class="numbers">{{plan.form_quota}}</span> Forms</li>
          <li class="pricing-features-item"><span class="numbers">{{plan.user_quota}}</span> Team members to be invited</li>
          <li class="pricing-features-item">Create up to <span class="numbers">{{plan.product_quota}}</span> Products </li>
          <li class="pricing-features-item">Enjoy these benefits for up to <span class="numbers">{{plan.duration}}</span> day(s)</li>
            <li class="pricing-features-item">More Info<feather-icon @click="showMoreInfo(plan.id)" class="cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/></li>
           <vs-popup :title="infoTitle" :active.sync="popupActive" >
            {{infoDescription}}
           </vs-popup>
        </ul>
        <span class="pricing-price">RM{{plan.price}}<span class="text-sm">/Month</span></span>
        <vs-button v-if="status == 'n'" class="pricing-button is-featured" :disabled="getSubscribed(plan.id)" @click="subscribeConfirmation(plan)">Subscribe Now</vs-button>
        <vs-button v-else class="pricing-button is-featured" @click="subscribeTrial(plan.id)">Start 14 days Free Trial</vs-button>
      </div>
      
    </div>
  </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
      popupActive: false,
      infoTitle: '',
      infoDescription: '',
      current_package: null,
      previous_package: null
    }
  },
  created() {
    Promise.all(
      [
        this.$store.dispatch('subscription/getSubscriptionStatus'),
        this.$store.dispatch('subscription/getPackageDetails').then((res) => {
          this.current_package = res
        }),
        this.$store.dispatch('subscription/checkPreviousPackage').then((res) => {
          this.previous_package = res
        })
      ])
    
  },
  computed: {
    plans() {
      return this.$store.state.subscription.packages
    },
    status() {
      return this.$store.state.subscription.status
    }
  },
  methods: {
    currentPlan(id){
      if(this.current_package !== null && this.current_package.subscription_id === id){
        return 'pricing-plan outline'
      }else{
        return 'pricing-plan'
      }
    },
    currentTag(id){
      if(this.current_package !== null && this.current_package.subscription_id === id){
        return true
      }else{
        return false
      }
    },
    showMoreInfo(id) {
      this.infoTitle = this.plans.find(p => p.id == id).name
      this.infoDescription = this.plans.find(p => p.id == id).description
      this.popupActive = true
    },
    subscribeTrial(id) {
      this.$store.dispatch('subscription/subscribeTrialPlan', { subscription_id: id })
      .then(() => {
        this.$vs.notify({
            title: 'Yay!',
            text: 'Trial package is now activated!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            time:2500
          })
        this.$router.push({path: '/dashboard'})
      })
      .catch((err)  => {console.log(err)})
    },
    subscribeConfirmation(plan){
      let previous = this.checkPrevious(plan)
      if(this.previous === true){
        if(this.current_package !== null){
          this.$vs.dialog({
            type: 'confirm',
            color: 'primary',
            title: 'Are you sure?',
            text: 'You currently subscribed '+this.current_package.name+' package end on '+this.current_package.end_date+'. If subscribe a new package will overwrite your current benefits.',
            accept: this.subscribe(plan.id),
          })
        }else{
          this.subscribe(id)
        }
      }else{
        this.$vs.dialog({
            color: 'primary',
            title: 'Opps!',
            text: 'You are not allowed to perform downgrade.'
        })
      }
      
    },
    subscribe(id){
      this.$store.dispatch('subscription/subscribePlan', { subscription_id: id })
      .then((res) => {
        if(res.data.data === 'success'){
          this.$vs.notify({
            title: 'Yay!',
            text: 'Package has now activated!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            time:2500
          })
        }else{
          this.$vs.notify({
            title: 'Oops!',
            text: 'Something wrong, kindly try again later!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            time:2500
          })
        }
        this.$router.push({path: '/dashboard'})
      })
      .catch((err)  => {console.log(err)})
    },
    getSubscribed(id){
      if(this.current_package !== null && this.current_package.subscription_id === id){
        return true
      }else{
        return false
      }
    },
    checkPrevious(plan){
      if(this.previous_package.product_quota >= plan.product_quota && 
         this.previous_package.form_quota >= plan.form_quota &&
         this.previous_package.user_quota >= plan.user_quota ){
          return true
      }else {
        return false
      }
    }
  }

}
</script>

<style scoped>
html {
  box-sizing: border-box;
}

*, *:before, *:after {
  box-sizing: inherit;
}

.background {
  padding: 0 25px 25px;
  position: relative;
  width: 100%;
}

.container {
  margin: 0 auto;
  padding: 50px 0 0;
  max-width: 960px;
  width: 100%;
}

.panel {
  background-color: #fff;
  border-radius: 10px;
  padding: 15px 25px;
  position: relative;
  width: 100%;
  z-index: 10;
}

.pricing-table {
  box-shadow: 0px 10px 13px -6px rgba(0, 0, 0, 0.08), 0px 20px 31px 3px rgba(0, 0, 0, 0.09), 0px 8px 20px 7px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
}

.pricing-table * {
  text-align: center;
  text-transform: uppercase;
}

.pricing-plan {
  border-bottom: 1px solid #e1f1ff;
  padding: 25px;
}

.outline{
  outline: #F9278E 2px solid;
}

.current_plan{
  width: 200px;
  height: 30px;
  background-color: #F9278E;
  color: #fff;
  top: 45px;
  position: relative;
  font-weight: 500;
  transform: translateX(30px);
}

.current_plan:before{
  content: "";
  position: absolute;
  left:0;
  bottom: -10px;
  border-top: 5px solid  #C71F72;
  border-bottom: 5px solid transparent;
  border-left: 5px solid transparent;
  border-right: 5px solid #C71F72;
}

.current_plan:after{
  content: "";
  position: absolute;
  right:0;
  bottom: -10px;
  border-top: 5px solid  #C71F72;
  border-bottom: 5px solid transparent;
  border-left: 5px solid #C71F72;
  border-right: 5px solid transparent;
}

.current_plan .sub-current-plan1,
.current_plan .sub-current-plan2{
  position: absolute;
  width: 30px;
  height:30px;
  background:#F9278E;
  top:10px;
  z-index: -1;
}

.current_plan .sub-current-plan1{
  left: -20px;
}

.current_plan .sub-current-plan2{
  right: -20px;
}

.current_plan .sub-current-plan1:before{
  content:'';
  position: absolute;
  top:0;
  left: 0;
  border-left: 15px solid #fff;
  border-right: 15px solid transparent;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
}

.current_plan .sub-current-plan2:before{
  content:'';
  position: absolute;
  top:0;
  left: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid #fff;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
}


.pricing-plan:last-child {
  border-bottom: none;
}

@media screen and (min-width: 900px) {
  .background {
    padding: 0 0 25px;
  }

  .pricing-table {
    flex-direction: row;
  }

  .pricing-plan {
    border-bottom: none;
    border-right: 1px solid #CCCCCC;
    flex-basis: 100%;
    padding: 25px 50px;
  }

  .pricing-plan{
    border-right: none;
  }

  .current_plan{
    transform: translateX(0);
  }
 
}

.pricing-img {
  margin-bottom: 25px;
  max-width: 100%;
}

.pricing-header {
  color: #888;
  font-weight: 600;
  letter-spacing: 1px;
}

.pricing-features {
  color: #F9278E;
  font-weight: 450;
  letter-spacing: 1px;
  margin: 50px 0 25px;
}

.pricing-features-item {
  border-top: 1px solid #CCCCCC;
  font-size: 12px;
  line-height: 1.5;
  padding: 15px 0;
}

.pricing-features-item:last-child {
  border-bottom: 1px solid black;
}

.pricing-price {
  color: #F9278E ;
  display: block;
  font-size: 20px;
  font-weight: 600;
}

.pricing-button {
  color: #F9278E;
  display: inline-block;
  margin: 25px 0;
  padding: 15px 35px;
  text-decoration: none;
  transition: all 150ms ease-in-out;
}


.pricing-button.is-featured {
  color: #fff;
}

.numbers {
  font-size: 22px;
}

.days{
  color:#F9278E;
  text-decoration: underline;
}
</style>
